<template>
  <v-app :id="homepage ? 'site-app' : 'inspire'">
    <slot><router-view /></slot>

    <EventBus
      @onOpenPostDetaildDialog="onOpenPostDetaildDialog"
      @onViewImages="onViewImages"
      @onOpenCommentDetailDialog="onOpenCommentDetailDialog"
    />

    <PostDetailDialog
      :poid="poid"
      :showDialog.sync="showPostDetailDialog"
    />

    <CommentDetailDialog
      :showDialog.sync="showCommentDetailDialog"
      :from="commentFrom"
    />

    <Crx />

    <MaintenancePage />

    <div
      v-viewer="options"
      class="images "
    >
      <template v-for="{source, thumbnail} in images">
        <img
          :key="source"
          :src="thumbnail"
          :data-source="source"
          :alt="source"
          class="image"
        >
      </template>
    </div>
  </v-app>
</template>

<script>
import PostDetailDialog from './views/_merchant/post/DetailDialog'
import CommentDetailDialog from './views/_merchant/comment/DetailDialog'
import Crx from './views/home/components/Crx'
import MaintenancePage from '@g/components/MaintenancePage.vue'
import { upyun } from '@g/filters'

export default {
  name: 'App',
  props: { homepage: Boolean },
  components: {
    PostDetailDialog,
    Crx,
    CommentDetailDialog,
    MaintenancePage,
  },
  data () {
    return {
      poid: '',
      showPostDetailDialog: false,

      snapshots: [],

      options: {
        toolbar: true,
        url: 'data-source',
        initialViewIndex: 0,
      },
      images: {},

      commentFrom: '',
      showCommentDetailDialog: false,
    }
  },
  watch: {
    '$store.state.userData.uid': {
      handler: 'setGtagUserId',
      immediate: true,
    },
  },
  mounted () {
    this.$store.dispatch('option/app')
  },
  methods: {
    setGtagUserId () {
      if (this.$store.state.userData.uid) {
        window.gtag && window.gtag('set', { user_id: this.$store.state.userData.uid })
      }
    },
    onOpenPostDetaildDialog (poid) {
      this.poid = poid
      this.showPostDetailDialog = true
    },
    async onViewImages (obj) {
      let images
      if (Array.isArray(obj)) {
        images = obj
      } else {
        images = obj.images
      }
      this.images = images.map(item => {
        return {
          thumbnail: upyun(item, '!/fh/68'),
          source: upyun(item),
        }
      })
      await this.$nextTick()
      setTimeout(() => {
        const viewer = this.$el.querySelector('.images').$viewer
        viewer.view(obj.index || 0)
      }, 100) // 插件BUG，不加 settimeout 不显示
    },
    onOpenCommentDetailDialog ({ from = '' } = {}) {
      console.log('onOpenCommentDetailDialog', from)
      this.commentFrom = from
      this.showCommentDetailDialog = true
    },
  },
}
</script>
<style lang="postcss" scoped>
.images {
  display: none;
}
</style>
